// Legacy layer slugs → current slugs, for URLs shared before the AMF-22763
// viewer clean-up.
//
// `?layers=` and `?revisions=` address layers by a slug derived from the
// layer's display name (`getLayerSlug`), so the wholesale rename in that
// clean-up invalidated every link people had saved. A stale slug does not
// error — it simply matches no registered control, and the layer silently
// fails to come back, which is the worst way for this to break.
//
// Entries only exist where the *slug* actually changed. The `dev` → `DEV`
// renames are absent on purpose: slugs are lower-cased, so those map to
// themselves.
//
// This table is append-only in spirit. Removing an entry re-breaks whatever
// links it was covering, and layers deleted by the clean-up are deliberately
// not listed — there is nothing to point them at. The lane-restriction flavour
// aliases are the one exception: they moved to LEGACY_VIEW_REFS in
// layerViews.mjs when the flavours became views of one row (AMF-23106).
export const LEGACY_LAYER_SLUGS = {
  "caj-rm-dev-66578": "rm-caj-dev-66578",
  "caj-rm-prod-64504": "rm-caj-64504",
  "crosslink-prod-32804-incl-hapt": "crosslink-32804",
  "crosslink-staging-20986-hdbm-27593": "crosslink-staging-20986-lmbm-27593",
  "crosslink-staging-20986-hdbm-29351": "crosslink-staging-20986-lmbm-29351",
  "genesis-sd-gradient": "genesis-gradient",
  "gradient-prod-11880": "gradient-11880",
  "hd-basemap-29351-incl-hapt": "lm-basemap-29351",
  "hd-lane-borders-29351-incl-hapt": "lm-lane-borders-29351",
  "hd-lane-width-dev-16712": "lm-lane-width-dev-16712",
  "hd-lane-width-prod-49829": "lm-lane-width-49829",
  "lm-curvature-prod-20906": "lm-curvature-20906",
  "lm-derived-caj-prod-62511": "lm-derived-caj-62511",
  "lm-lane-restrictions-internals-prod": "lm-lane-restrictions-internals",
  "lm-lane-restrictions-prod-88259": "lm-lane-restrictions-88259",
  "lm2rm-curvature-dev-15916": "lm-derived-cor-dev-15916",
  "lm2rm-curvature-prod-15751": "lm-derived-cor-15751",
  "lrtc-hd-dev-74020": "lrtc-lm-dev-74020",
  "lrtc-hd-prod-93924": "lrtc-lm-93924",
  "rm-curvature-cariad-prod-97905": "rm-curvature-cariad-97905",
  "rm-curvature-prod-23405": "rm-curvature-23405",
  "rm-lane-restrictions-prod-21620-internals":
    "rm-lane-restrictions-21620-internals",
  "rm-lane-restrictions-prod-21620-moderations":
    "rm-lane-restrictions-21620-moderations",
};

// Current slug for `slug`, which may be a legacy one. Unknown slugs pass
// through untouched: a slug for a layer that no longer exists still finds no
// control, exactly as before.
export function resolveLayerSlug(slug) {
  return Object.hasOwn(LEGACY_LAYER_SLUGS, slug)
    ? LEGACY_LAYER_SLUGS[slug]
    : slug;
}
